import { Alert, Button, Modal, Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { DocumentSelectionStep } from '.';
import { TestProjectDataStore, TestProjectWizardStore } from '../stores';

type Props = {
    store: TestProjectWizardStore;
    testProjectDataStore: TestProjectDataStore;
};

const TestProjectPackagesEditDialog: React.FC<Props> = ({ store, testProjectDataStore }) => {
    const [errorMessage, setErrorMessage] = React.useState<string | null>(null);

    const capturedTestProjectDataStore = store.testProjectDataStore;
    const isEditingProject = store.isEditingProject(testProjectDataStore);

    const handleCancel = () => {
        store.setPackagesEditDialogVisible(false);
        store.resetWizard();
        setErrorMessage(null);
    };

    const handleSave = () => {
        if (!isEditingProject || !store.canEditProject) {
            return;
        }

        if (store.selectedPackages.length === 0) {
            setErrorMessage('Please select at least one document!');
        } else {
            setErrorMessage(null);
            store
                .updateTestProjectPackages()
                .then(successful => {
                    if (successful) {
                        if (store.testProjectDataStore === capturedTestProjectDataStore) {
                            handleCancel();
                        }

                        testProjectDataStore.loadTestProject();
                    }
                })
                .catch(() => {
                    // Do nothing
                });
        }
    };

    return (
        <Modal
            visible={store.packagesEditDialogVisible && isEditingProject}
            title={store.currentTestProject ? `Edit documents for ${store.currentTestProject.name}` : 'Edit documents'}
            onCancel={handleCancel}
            maskClosable={false}
            centered
            destroyOnClose
            width={850}
            footer={[
                <Button
                    key="save-packages"
                    type="primary"
                    onClick={handleSave}
                    disabled={!store.canEditProject}
                    size="large"
                >
                    Save
                </Button>
            ]}
        >
            {errorMessage && <Alert message={errorMessage} style={{ marginBottom: 12 }} type="error" />}
            {store.testProjectLoadError && (
                <Alert
                    message={store.testProjectLoadError}
                    type="error"
                    action={<Button onClick={store.retryTestProjectSetup}>Retry</Button>}
                />
            )}
            {store.isSettingUpTestProject && <Spin />}
            {store.canEditProject && <DocumentSelectionStep store={store} />}
        </Modal>
    );
};

export default observer(TestProjectPackagesEditDialog);
